import { X_AT_KEY, destroy, post, put } from '@alltrails/shared/api';
import { PhotosResponse, MetaResponse } from '@alltrails/denali/types';

const deletePhoto = async (photoId: number) => destroy<void>(`/api/alltrails/photos/${photoId}`);

const suggestDeletePhotoFromTrail = async (trailId: number, photoId: number) => {
  post<void>(`/api/alltrails/photos/${photoId}/suggest_delete`, {
    trail_id: trailId
  });
};

const unhidePhoto = async (photoId: number) => post<MetaResponse>(`/api/alltrails/photos/${photoId}/unhide`, {});

const removePhotoFromMap = async (mapId: number, photoId: number) => post<MetaResponse>(`/api/alltrails/maps/${mapId}/photos/${photoId}`, {});

const removePhotoFromTrail = async (trailId: number, photoId: number) =>
  post<MetaResponse>(`/api/alltrails/trails/${trailId}/photos/${photoId}/remove`, {});

const setAsMapProfilePhoto = async (mapId: number, photoId: number) =>
  post<MetaResponse>(`/api/alltrails/maps/${mapId}/profile_photo`, {
    photo_id: photoId
  });

const setAsTrailProfilePhoto = async (trailId: number, photoId: number) =>
  post<MetaResponse>(`/api/alltrails/v1/trails/${trailId}/profile_photo`, { photo_id: photoId, api_key: X_AT_KEY });

const setAsListProfilePhoto = async (listId: number, photoId: number) =>
  post<MetaResponse>(`/api/alltrails/lists/${listId}/profile_photo`, {
    photo_id: photoId,
    return_photo: true
  });

const renamePhoto = async (photoId: number, title: string) =>
  put<PhotosResponse[]>(`/api/alltrails/photos/${photoId}`, {
    title
  });

export {
  deletePhoto,
  removePhotoFromMap,
  removePhotoFromTrail,
  setAsListProfilePhoto,
  setAsMapProfilePhoto,
  setAsTrailProfilePhoto,
  suggestDeletePhotoFromTrail,
  unhidePhoto,
  renamePhoto
};
